/**
 * KAN-826: counters of supplementing records and organizations in the upload
 * result. Nothing is rendered when they are absent or all zero (a plain 200
 * upload always carries them as 0).
 */
import { UPDATE_COUNTERS, hasUpdateCounters } from '@/lib/uploadSummary';
import type { UploadResult } from '@/types/dataset';

export function UploadUpdateCounters({ result }: { result: UploadResult }): JSX.Element | null {
  if (!hasUpdateCounters(result)) return null;
  const present = UPDATE_COUNTERS.filter(({ key }) => result[key] !== undefined);
  return (
    <ul data-testid="upload-update-counters" className="space-y-1 mt-2">
      {present.map(({ key, label }) => (
        <li key={key}>
          {label}: <strong>{result[key]}</strong>
        </li>
      ))}
    </ul>
  );
}
